import vIcon from '@/components/form/v-icon';
import vIconButton from '@/components/form/v-icon-button';
import {RButton} from '@rebilly/recomponents';

/**
 * Return the element structure for a preset or icon when provided.
 * @param {string} name
 * @param {{}} style
 * @return {*}
 */
const compilePreset = (name, {style}) => {
    const map = {
        // todo: icon download name
        download: () => [
            vIcon,
            {
                props: {
                    icon: !style.icon ? 'download' : style.icon,
                },
            },
        ],
        edit: () => [
            vIcon,
            {
                props: {
                    icon: !style.icon ? 'edit' : style.icon,
                },
            },
        ],
        delete: () => [
            vIcon,
            {
                props: {
                    icon: !style.icon ? 'trash' : style.icon,
                },
            },
        ],
    };

    if (!map[name]) {
        if (style.icon) {
            return [
                vIcon,
                {
                    props: {
                        icon: style.icon,
                    },
                },
            ];
        }
        // if on icon is specified, prevent rendering
        throw new Error(`Undefined preset ${name}`);
    }
    return map[name]();
};
/**
 * Renders a button for display.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function buttonColumn({
    cachedColumn, rowData, createElement, grid,
}) {
    let children = [];
    if (!cachedColumn.style) {
        throw new Error(`Grid button column: Please define a style object. Include either a preset, label or type`);
    }
    if (!cachedColumn.props.click) {
        throw new Error(`Grid button column: Please define a click event`);
    }

    const {style} = cachedColumn;
    const preset = style.preset || style.icon;
    const parentComponent = style.label && !preset ? RButton : vIconButton;
    const parentProps = {
        props: {
            size: 'small',
            type: style.type !== null ? style.type : '',
            tooltip: cachedColumn.style.tooltip !== null ? cachedColumn.style.tooltip : null,
            tooltipRightEdge: true,
        },
        on: {
            click: function click(evt) {
                cachedColumn.props.click({rowData, grid, evt});
            },
        },
    };
    // Set disabled based on delegate column prop isDisabled
    if (cachedColumn.props.isDisabled && cachedColumn.props.isDisabled({rowData})) {
        parentProps.props.disabled = true;
    }
    let childrenOfButton = [];
    // Button presets are base buttons icon and overwrite any other styles
    if (preset) {
        parentProps.props.style = 'has-icon';
        parentProps.props.type = 'basic';
        childrenOfButton.push(
            createElement(...compilePreset(
                preset,
                {style},
            )),
        );
    } else {
        childrenOfButton = style.label;
    }
    children = [
        createElement(
            parentComponent,
            parentProps,
            childrenOfButton,
        ),
    ];

    return [
        'div', {
            class: 'is-button',
        },
        children,
    ];
}
